<template>
  <el-dialog
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="800px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
    :append-to-body="true"
  >
    <span slot="title" class="el-dialog__title">
      <template v-if="DialogFormData.module == 'quotation'">
        {{ l("我要询价") }}
      </template>
      <template v-else-if="DialogFormData.module == 'purchase'">
        {{ l("我要报价") }}
      </template>
      <template v-else-if="DialogFormData.module == 'raise'">
        {{ l("我要拼单") }}
      </template>
    </span>
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-width="100px"
      label-position="left"
    >
      <el-row>
        <el-col
          v-if="
            DialogFormData.module == 'quotation' ||
            DialogFormData.module == 'raise'
          "
          :span="24"
          key="amount"
        >
          <el-form-item :label="l('采购量') + '：'" prop="amount">
            <el-input
              v-model="DialogFormData.amount"
              :placeholder="
                DialogFormData.module == 'raise'
                  ? l('请输入不小于起拼量的数字') +
                    ' ' +
                    business_detail.start_amount
                  : l('采购量')
              "
              :disabled="Type == 'View'"
            >
              <template slot="append">
                {{ business_detail.specification_amount[0].unit }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col
          v-else-if="DialogFormData.module == 'purchase'"
          :span="18"
          key="price"
        >
          <el-form-item :label="l('价格') + '：'" prop="price">
            <el-row>
              <el-col :span="14">
                <el-input v-model="DialogFormData.price" :placeholder="l('价格')" :disabled="Type == 'View'">
                </el-input>
              </el-col>
              <el-col :span="10">
                <el-select v-model="DialogFormData.unit" :disabled="Type == 'View'">
                  <el-option v-for="item in $store.state.basicInfo.unitList" :key="item" :label="'元/' + item"
                    :value="item"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>
        <el-col :span="18" key="deliver_status">
          <el-form-item :label="l('交货状态') + '：'" prop="deliver_status">
            <el-input v-model="DialogFormData.deliver_status" :placeholder="l('交货状态')" :disabled="Type == 'View'">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="l('补充说明') + '：'" prop="extra_params">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.extra_params"
              :placeholder="l('可以输入交货时间、交货地等补充说明')"
              :maxlength="100"
              :show-word-limit="true"
              resize="none"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="DialogFormData.module == 'purchase'" key="img_array">
          <ResourceListUpLoad
            label="图片："
            prop="img_array"
            file_type="image"
            usage="purchase"
            :initResourceUrl.sync="DialogFormData.img_array"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>

      <template v-if="Type == 'View'">
        <el-button type="warning" @click="Type = 'Edit'">{{l("修 改")}}</el-button>
        <el-button
          type="success"
          v-show="DialogFormData.status != 1 && Type == 'View'"
          @click="online"
          >{{l("通过")}}</el-button
        >
      </template>

      <el-button v-if="Type == 'Edit'" type="primary" @click="submitForm"
        >{{l("保 存")}}</el-button
      >
    </span>

  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "BusinessDialog",
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        code: "", //询报价code
        business_code: "", //来源code
        module: "",
        amount: null,
        price: null,
        address: "",
        extra_params: "",

        //报价允许上传图片
        img_array: [],
        unit: null,//报价自定义单位
        deliver_status: "",//报价交货状态

        status: null //审核状态 不参与编辑
      },
      business_detail: {},//原本的商品/求购/拼单目标信息
      dialogRules: {
        price: [
          {
            required: true,
            message: this.l("请输入") + this.l("价格"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^([\d.])+$/.test(value)) {
                callback(new Error(this.l("请输入") + this.l("数字")));
              } else {
                callback();
              }
            },
          },
        ],
        amount: [
          {
            required: true,
            message: this.l("请输入") + this.l("采购量"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (
                this.DialogFormData.module == "raise" &&
                (this.DialogFormData.amount !=
                  Number(this.DialogFormData.amount) ||
                  this.DialogFormData.amount <
                    this.business_detail.start_amount)
              ) {
                callback(
                  new Error(
                    this.l("请输入不小于起拼量的数字") +
                      this.business_detail.start_amount
                  )
                );
              } else {
                if (!/^([\d.])+$/.test(value)) {
                  callback(new Error(this.l("请输入") + this.l("数字")));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        deliver_status: [
          {
            required: true,
            message: this.l("请输入") + this.l("交货状态"),
            trigger: "blur",
          }
        ],
      },
    };
  },
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        // console.log("AuthBusinessDialog DialogFormData",this.DialogFormData)
        //修改历史询报价
        this.axios
          .get(
            `/api/admin_business_action/${this.DialogFormData.code}/`
          )
          .then((response) => {
            this.DialogFormData = response;
            if(response.img_array){
              this.DialogFormData.img_array = JSON.parse(response.img_array);
            }
            if(this.DialogFormData.module=="purchase"){
              this.axios
                .get(
                  `/api/visitor_purchase/${this.DialogFormData.business_code}/`
                ).then(res=>{
                  this.business_detail = res;
                  resolve();
                })
            }
          })
          .catch((e) => {
            reject();
          });
      });
    },
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .put(`/api/admin_business_action/${this.DialogFormData.code}/`, {
            ...this.DialogFormData,
            img_array:JSON.stringify(this.DialogFormData.img_array)
          })
          .then(() => {
            this.$emit("submitDialog");
            this.Hide();
          });
    

      });
    },
    online(){
      this.$confirm(`是否通过审核?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .put(`/api/admin_business_action/${this.DialogFormData.code}/on/`)
          .then((data) => {
            this.$emit("submitDialog");
            this.Hide();
          });
      });
    }
  },
};
</script>


<style scoped lang="scss">
</style>

